export default {
  ru: {
    tap: 'Коснитесь экрана, чтобы начать',
    pending: 'Операция выполняется.<br>Пожалуйста, подождите ...',
    submit: 'Отправить',
    yes: 'Да',
    no: 'Нет',
    understand: 'Понятно',
  },
  en: {
    // en
  },
};
